import { donationsApi } from '../api/donationsApi'

export const deleteDonation = async (donationId: string) => {
  try {
    const { data } = await donationsApi.deleteDonation(donationId)
    return data
  } catch (error) {
    console.error(`Error deleting donation: `, error)
    throw error
  }
}
